import Cookies from 'js-cookie';

import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";
import { dialog } from "../../components/dialog.js";
import { gtm } from "../../components/gtm.js";
import { utils } from '../../helpers/utils.js';
import { theme } from '../../helpers/theme.js';

/*------------------------------------*\
  #COMPARATOR
\*------------------------------------*/
class Comparator {
  constructor(module){
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    this.COOKIE = 'COMPARATEUR';
    this.COOKIES = { part: 'COMPARATEUR-PART', pro: 'COMPARATEUR-PRO' };
    this.maxItems = 4;

    if(debug.DEBUG) console.log('modules/comparator.js');
  }
  /**
   * SELECTION
   */
  selection = (id, name, cat) => {
    const cookieIds = this.cookieGetIds();
    const idExists = this.cookieIsIdExist(id);
  
    if (!idExists && cookieIds && cookieIds.length >= this.maxItems) {
      dialog.open('popin-comparator-full');
    } else {
      if (!idExists) {
        dialog.open('popin-add-comparator');
      }
      gtm.track({
        event: idExists ? 'removeFromComparator' : 'addToComparator',
        eventCategory: 'Comparator',
        eventAction: idExists ? 'remove_product' : 'add_product',
        eventLabel: cat,
        eventValue: name
      });
      return this.cookieSetId(id, !idExists);
    }
    return false;
  }
  /**
   * CookieIsIdExist
   * verification de l'existance d'un ID produit
   * dans la liste du comparateur
   * @param {*} id 
   */
  cookieIsIdExist = ($id) => {
    const cookieIds = this.cookieGetIds();
    return cookieIds ? cookieIds.includes($id) : false;
  };
  /**
   * CookieGetIds
   * récupération des id dans le cookie
   */
  cookieGetIds = () => {
    const cookieIds = Cookies.get(this.COOKIES[theme.get()]);
    return cookieIds ? cookieIds.split(',') : [];
  };
  /**
   * Sets or removes a cookie based on the length of the provided cookie IDs array.
   *
   * @param {Array} cookieIds - An array of cookie IDs. If the array is not empty, the cookie will be set. If the array is empty, the cookie will be removed.
   */
  cookieSetIds = (cookieIds) => {
    Cookies[cookieIds.length ? 'set' : 'remove'](this.COOKIES[theme.get()], cookieIds);
  }
  /**
   * CookieSetId
   * ajout de la liste d'ID produit au cookie
   * @param {string} id 
   */
  cookieSetId = (id, toAdd) => {
    let cookieIds = this.cookieGetIds();
    const index = cookieIds.indexOf(id);
    const exists = index > -1;
  
    if (toAdd && !exists) {
      cookieIds.push(id);
    } else if (!toAdd && exists) {
      cookieIds.splice(index, 1);
    }
  
    this.cookieSetIds(cookieIds);
    utils.dispatchEvent('COMPARATOR_HAS_CHANGER');
    return toAdd && !exists;
  }
}
export const comparator = new Comparator(); 
document.addEventListener("DOMContentLoaded", function() {
  comparator.init();
});